module.exports = "/* You can add global styles to this file, and also import other style files */\nbody {\n  background: #D4DDF7;\n  color: #2A0934;\n  height: 100%;\n  margin: 0;\n  padding: 0;\n  -webkit-font-smoothing: antialiased; }\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./node_modules/postcss-loader/lib??embedded!./node_modules/sass-loader/lib/loader.js??ref--8-3!./src/styles.scss
// module id = ./node_modules/raw-loader/index.js!./node_modules/postcss-loader/lib/index.js??embedded!./node_modules/sass-loader/lib/loader.js??ref--8-3!./src/styles.scss
// module chunks = styles